import { render, staticRenderFns } from "./PhaseToPhase.UK.1.vue?vue&type=template&id=a486d99e&scoped=true"
import script from "./PhaseToPhase.UK.1.vue?vue&type=script&lang=js"
export * from "./PhaseToPhase.UK.1.vue?vue&type=script&lang=js"
import style0 from "./PhaseToPhase.UK.1.vue?vue&type=style&index=0&id=a486d99e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a486d99e",
  null
  
)

export default component.exports